<template>
  <section>
    <div class="sm:hidden mt-96 w-full container overflow-hidden">
      <swiper
        :slides-per-view="1"
        :space-between="0"
        :direction="vertical"
        :mousewheel="{ releaseOnEdges: false }"
        :freeMode="true"
        :speed="3000"
        :autoplay="{ delay: 8000, disableOnInteraction: true }"
        :loop="true"
        @scroll="onSlideChange"
        :autoHeight="true"
      >
        <swiper-slide v-for="(img, index) in selectedImageArray" :key="index">
          <img :src="require('../assets/menu/' + img)" alt="" />
        </swiper-slide>
      </swiper>
    </div>
    <div class="relative w-24 h-auto circle-p z-10">
      <a href="https://sushishogun.zomi.menu/" target="_blank">
        <img
          v-bind:style="{ transform: 'rotate(' + deg + 'deg)' }"
          :src="require('@/assets/images/order-online-button.png')"
          alt=""
        />
      </a>
    </div>
    <div class="sm:block hidden w-full overflow-hidden">
      <swiper
        :slides-per-view="1"
        :space-between="0.5"
        :direction="horizontal"
        loop="true"
        :mousewheel="{ releaseOnEdges: false }"
        @scroll="onSlideChange"
      >
        <swiper-slide v-for="(img, index) in selectedImageArray" :key="index">
          <img :src="require('../assets/menu/' + img)" alt="" />
        </swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script>
import SwiperCore, { Mousewheel, Autoplay } from "swiper";
import "swiper/swiper.scss";
import { Swiper, SwiperSlide } from "swiper/vue";

SwiperCore.use([Mousewheel, Autoplay]);
export default {
  data() {
    return {
      deg: 0,
      imageArray: [
        ["MENU-appetizer-1.jpg", "MENU-appetizer-1.jpg"],
        ["MENU-sashimi-1.jpg", "MENU-sashimi-1.jpg"],
        ["MENU-sushi-1.jpg", "MENU-sushi-1.jpg"],
        [
          "MENU-sushiRoll-1.jpg",
          "MENU-sushiRoll-1.jpg",
          "MENU-sushiRoll-1.jpg",
          "MENU-sushiRoll-1.jpg",
          "MENU-sushiRoll-1.jpg",
          "MENU-sushiRoll-1.jpg",
          "MENU-sushiRoll-1.jpg"
        ],
        ["image-replacement-1.jpg"], //ALA-carte
        ["image-replacement-1.jpg"], //donburi
        ["image-replacement-1.jpg"],
        ["MENU-combo-1.jpg", "MENU-combo-1.jpg"], //combo
        ["MENU-noodle-1.jpg"], //noodle
        ["MENU-partytray-1.jpg"], //party tray
        ["image-replacement-1.jpg"] //lunch special
      ]
    };
  },
  computed: {
    key() {
      return this.$store.state.imageArrayKey;
    },

    selectedImageArray() {
      console.log(this.key);
      return this.imageArray[this.key];
    }
  },
  methods: {
    onSlideChange() {
      //in product we need to check image array
      //set degree for each slide
      this.deg += 360 / 50;
    }
  },

  components: {
    Swiper,
    SwiperSlide
  }
};
</script>

<style scoped>
.left-96 {
  left: 22rem;
}
.swiper-slide {
  /*height: 60vh !important;*/
  display: flex;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-container {
  height: 100%;
  width: 100%;
}
.circle-p {
  top: -20rem;
  left: 88%;
}
@media only screen and (min-width: 1535px) and (max-width: 1920px) {
  .swiper-slide {
    /*height: 90vh !important;*/
  }
  .circle-p {
    top: -28rem;
    left: 92%;
  }
}
</style>